export default __webpack_public_path__ + "static/media/bird.cdfe8479.png";